import { createContext } from "react";
import { TDeductionIncompleteContextType } from "../interface/deductionIncomplete.interface";
import { DocumentMimeType } from "@/core/enums/DocumentMimeType";

export const DeductionIncompleteContext = createContext<TDeductionIncompleteContextType | undefined>(undefined);

// Constants
export const DEDUCTION_BACKUP_FILE_CONSTANTS = {
  COSTCO_MAX_LENGTH: 1,
  KEHE_MAX_LENGTH: 1,
  MAX_LENGTH: 5,
  MAX_SIZE_MB: 2,
  MAX_FILE_NAME_LENGTH: 20,
  ACCEPTED_TYPES: [DocumentMimeType.PDF, DocumentMimeType.EXCEL, DocumentMimeType.EXCEL_LEGACY, DocumentMimeType.CSV],
  ACCEPTED_EXTENSIONS: ["pdf", "xlsx", "xls", "csv"],
  COSTCO_ACCEPTED_TYPES: [DocumentMimeType.PDF],
  COSTCO_ACCEPTED_EXTENSIONS: ["pdf"],
};

export enum SelectionMode {
  SINGLE = "single",
  MULTIPLE = "multiple",
}

export enum PurchaserKeys {
  UNFI_WEST = "UNFI_WEST",
  COSTCO = "COSTCO",
  UNFI_EAST = "UNFI_EAST",
  DOT_FOODS = "DOT_FOODS",
  KEHE = "KEHE",
  SUPERVALU = "SUPERVALU",
}

export const getMaxFilesAllowed = (purchaserKey?: string) => {
  if (purchaserKey === PurchaserKeys.COSTCO) {
    return DEDUCTION_BACKUP_FILE_CONSTANTS.COSTCO_MAX_LENGTH;
  }
  if (purchaserKey === PurchaserKeys.KEHE) {
    return DEDUCTION_BACKUP_FILE_CONSTANTS.KEHE_MAX_LENGTH;
  }
  return DEDUCTION_BACKUP_FILE_CONSTANTS.MAX_LENGTH;
};

export const getFileSize = (file: File): number => file.size / 1024 / 1024; // Returns size in MB

export const getFileSizeInString = (file: File): string => {
  const sizeInMB = getFileSize(file);
  return sizeInMB < 1 ? `${(file.size / 1024).toFixed(2)} KB` : `${sizeInMB.toFixed(2)} MB`;
};

// Utility function to generate unique file IDs
let fileIdCounter = 0;
export const generateUniqueFileId = (): string => {
  fileIdCounter++;
  // Use cryptographically secure random values instead of Math.random()
  const randomBytes = new Uint8Array(4);
  crypto.getRandomValues(randomBytes);
  const randomString = Array.from(randomBytes)
    .map(byte => byte.toString(36))
    .join("")
    .substring(0, 7);
  return `file_${Date.now()}_${fileIdCounter}_${randomString}`;
};
